module.exports = __webpack_public_path__ + "img/verve.412797a5.svg";